import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './ingredient-list.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    ingredients: '<',
    locked: '<',
    selectedIngredients: '<',
    unitsDisplay: '<',
    unitPerContainer: '<',
    showHeader: '<'
  },
  controller: class IngredientListComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    $onInit() {
      this.query = getQuery();
      this.limitOptions = getLimitOptions();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/ingredient-list/ingredient-list.component.js